<template>
  <div class="tab-content sort-type" id="mypage-edu-job-link-template">
    <div class="job-list-container">
      <div class="no-data" v-if="totalCount === 0">지원 가능한 교육 연계 공고가 없습니다.</div>
      <div class="job-card-grid new-type" v-else>
        <JobCard
          v-for="(item, index) in normalizedDisplayedList"
          :key="index"
          :item="item"
          @favorite-toggle="toggleFavorite"
        />
      </div>
      <div class="button-area btn-load-more" v-if="totalCount > viewCount">
        <button type="button" @click="more">
          <i class="ico ico-plus"></i>
          더보기
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import JobCard from '../components/JobCard.vue';

const WorkConditionCode = {
  IN60001: '정규직',
  IN60002: '계약직',
  IN60003: '인턴직',
  IN60004: '파트타임',
  IN60005: '기타',
};

const CareerHistoryCode = {
  ANY: '경력무관',
  NEW: '신입',
  EXPERIENCED: '경력',
};

export default {
  name: 'mypage-edu-job-link-template',
  props: ['isLogin'],
  components: {
    JobCard,
  },
  data() {
    return {
      list: [],
      viewCount: 12,
      totalCount: 0,
      WorkConditionCode,
      CareerHistoryCode,
    };
  },
  computed: {
    displayedList() {
      return this.list.slice(0, this.viewCount);
    },
    normalizedDisplayedList() {
      return this.displayedList.map(item => ({
        ...item,
        // JobCard가 기대하는 필드명으로 변환
        ANN_NM: item.ANN_NM,
        BIZ_SE: item.BIZ_SE,
        BIZ_SE_NM: item.BIZ_SE_NM,
        OPER_ORG_NM: item.OPER_ORG_NM,
        rcptPpl: item.rcptPpl,
        APPDURNG_STED: item.APPDURNG_STED,
        FAVORITE_YN: item.FAVORITE_YN || 'N',
        DDAY: item.DDAY,
        ANN_RCRT_STAT: item.ANN_RCRT_STAT,
        // 추가 필드들
        actamtHamt: item.actamtHamt,
        workConditionLabel: item.workConditionLabel,
      }));
    },
  },
  watch: {},
  methods: {
    getList() {
      Axios.get('/api/anns/availableByPassedRequireLectures')
        .then((response) => {
          const jobList = response.data.data.map(job => ({
            ...job,
            annType: (job.BIZ_SE.includes('JB')) ? 'JB' : 'IN',
            viewUrl: (job.BIZ_SE.includes('JB'))
              ? `/appView.do?ANN_NO=${job.ANN_NO}`
              : `/in_appView.do?ANN_NO=${job.ANN_NO}`,
            rcptPpl: job.RCRT_PPL.toLocaleString('ko-KR'),
            actamtHamt: job.ACTAMT_HAMT.toLocaleString('ko-KR'),
            workConditionLabel: (!job.WORK_CONDITION) ? this.WorkConditionCode[job.WORK_CONDITION] : '',
            careerHistoryLabel: (!job.CAREER_HISTORY) ? this.CareerHistoryCode[job.CAREER_HISTORY] : '',
          }));
          this.list = [...this.list, ...jobList];
          this.totalCount = this.list.length;
        }).catch((e) => {
          console.log(e);
        });
    },
    more() {
      this.viewCount += 8;
    },
    toggleFavorite(item) {
      if (!this.isLogin) {
        alert('로그인 후 이용 가능합니다.');
        return;
      }

      const isFavorite = item.FAVORITE_YN === 'Y';
      const confirmText = isFavorite ? '취소' : '등록';
      if (!confirm(`해당 공고를 관심 ${confirmText}하시겠습니까?`)) {
        return;
      }

      const method = isFavorite ? 'DELETE' : 'POST';
      Axios({
        url: `/api/favorite-anns/${item.annType}/${item.ANN_NO}`,
        method,
      }).then(() => {
        // 찜하기 취소 시 목록에서 제거
        if (isFavorite) {
          this.list = this.list.filter(i => i.ANN_NO !== item.ANN_NO);
        }
      }).catch((error) => {
        const errorMessage = (error.response && error.response.data && error.response.data.message) || '처리 중 오류가 발생했습니다. 다시 시도해 주세요.';
        alert(errorMessage);
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>



// WEBPACK FOOTER //
// MypageEducationJobLink.vue?35083df4